import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createTicketRequest } from '../api/ticketRequestApi'

/**
 * Yeni talep oluşturma mutation'ı. Başarıda liste ve KPI özet sorgularını geçersiz kılar
 * (yeni kayıt Talep Listesi'nde en üstte Beklemede görünür; sayımlar güncellenir).
 */
export function useCreateTicketRequest() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createTicketRequest,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ticket-requests'] })
      queryClient.invalidateQueries({ queryKey: ['ticket-summary'] })
    },
  })
}
